<homey-page-title title="Notification preferences" class="mb-1"/>

@if (loading() || !preferences()) {
  <div class="space-y-2">
    @for (_ of [0,1,2]; track _) {
      <div class="flex flex-row justify-between items-center py-2">
        <div class="space-y-2 w-full pr-4">
          <p-skeleton height="1rem" width="40%"></p-skeleton>
          <p-skeleton height="0.9rem" width="55%"></p-skeleton>
        </div>
        <p-skeleton height="1.5rem" width="3.5rem" styleClass="flex-shrink-0"></p-skeleton>
      </div>
      <p-divider class="p-0 m-0"/>
    }
  </div>
} @else {
  @if (error(); as errorMessage) {
    <div class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 mb-3">
      {{ errorMessage }}
    </div>
  }

  <div class="flex flex-row justify-between items-center py-2">
    <div class="flex flex-col">
      <p class="m-0 font-medium text-surface-900">Lottery updates</p>
      <p class="text-sm text-surface-500 m-0 mt-1">Application and drawing notices to keep you informed.</p>
    </div>
    <span class="text-sm font-semibold text-emerald-600">On</span>
  </div>
  <p-divider class="p-0 m-0"/>

  <div class="flex flex-row justify-between items-center py-2">
    <div class="flex flex-col">
      <p class="m-0 font-medium text-surface-900">Core account alerts</p>
      <p class="text-sm text-surface-500 m-0 mt-1">Security and policy updates you can’t opt out of.</p>
    </div>
    <span class="text-sm font-semibold text-emerald-600">On</span>
  </div>
  <p-divider class="p-0 m-0"/>

  <div class="flex flex-row justify-between items-center py-2">
    <div class="flex flex-col">
      <label for="promotionalNotifications" class="font-medium text-surface-900">Send non-lottery related messages</label>
      <p class="text-sm text-surface-500 m-0 mt-1">Tips, feature releases, and promotional messages.</p>
    </div>
    <p-toggleswitch
      inputId="promotionalNotifications"
      class="flex"
      [disabled]="saving()"
      [ngModel]="preferences()?.categories?.promotional ?? false"
      (onChange)="onPromotionalChange($event.checked)"/>
  </div>
}
